// TODO: Delete this file. All redirects now go to /status/[sessionId]
'use client';
import { analiticaInstance } from '@payments-checkout/shared/plugins/analitica/analitica.events';
import { usePaymentResponse } from '@payments-checkout/shared/providers';
import { Button, Icon } from '@stone-payments/jade';
import { CopyButton } from '../../../src/components/copyButton';
import { Replace } from '../../app/components/replace';
import { Success } from '../paymentStatus/paymentStatus';

export function BoletoSuccess() {
  const { paymentResponse } = usePaymentResponse();

  if (!paymentResponse) return <Replace />;

  if (!paymentResponse?.boleto) throw new Error('Boleto payment not found');

  const { barcode, line, url } = paymentResponse.boleto;

  function downloadBoleto() {
    window.open(url, '_blank');
    analiticaInstance.events.boletoPage.downloadClicked();
  }

  const sendAmplitudeEvent = () =>
    analiticaInstance.events.boletoPage.copyClicked();

  return (
    <Success
      icon={<Icon use="barcode-scanner" color="medium" size="xlarge" />}
      title="Pagar com boleto"
      subtitle="Pague sua compra com o código do boleto, que só é válido até a data indicada."
      paymentLine={line}
      image={
        <img
          src={barcode}
          className="w-[265px] h-[34px] md:mb-jade-100 md:w-[329px] md:h-[50px]"
        />
      }
    >
      <div className="w-full flex gap-jade-100 flex-col-reverse md:flex-row sm:flex-col">
        {line && (
          <CopyButton onCopy={sendAmplitudeEvent} textToCopy={line}>
            Copiar código
          </CopyButton>
        )}
        <Button
          variant="primary-solid"
          size="medium"
          icon="barcode"
          onClick={downloadBoleto}
          className="w-full"
        >
          Baixar boleto
        </Button>
      </div>
    </Success>
  );
}
